import { FC } from 'react';

import { cn } from '@/lib/utils';

import { ItemStatusEnum } from '../constants';

interface TableItemStatusProps {
  status: ItemStatusEnum;
}

export const TableItemStatus: FC<TableItemStatusProps> = ({ status }) => {
  return (
    <div
      className={cn(
        'w-fit text-sm text-center capitalize px-3 py-0.5 rounded-[24px] bg-transparent border border-accent text-accent',
        [ItemStatusEnum.Ready, ItemStatusEnum.Active].includes(status) &&
          'bg-transparent border border-green-500 text-green-500'
      )}
    >
      {status?.toLowerCase()}
    </div>
  );
};
